import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { GuestBuildingsDto } from "../../../../networking/data/responses/guestbuildings/GuestBuildingDto";
import { PurchaseHistory } from "../../../popups/marketplace/main/models/building/PurchaseHistory";
import { LandlordData } from "./LandlordData";

export class GuestBuilding {
    public readonly id: string;
    public readonly address: string;
    public readonly level: number;
    public readonly nextLevel?: number;
    public readonly imageUrl: string;
    public readonly area: number;
    public readonly city: string;
    public readonly costPerSqft: number;
    public readonly sqft: number;
    public readonly floors: number;
    public readonly borough: string;
    public readonly zipCode: string;
    public readonly upgradePointsBalance: number;
    public readonly requiredUpgradePoints?: number;
    public readonly visitCostInCoinsUpTo: number;
    public readonly landlord: LandlordData;
    public readonly piggyClubNftMultiplier?: number;
    public readonly piggyClubImageUrl?: string;
    public readonly piggyMultiplier?: number;
    public readonly priceInUsd: number;
    public readonly priceInEth: number;
    public readonly marketplaceId: string;
    public readonly tokenId: string;
    public readonly minBuildingLevelToAddToMp: number;
    public readonly needToFix: boolean;
    public readonly purchaseHistory: Array<PurchaseHistory>;

    public constructor(dto: GuestBuildingsDto) {
        this.validateDto(dto);
        this.id = dto.id;
        this.address = dto.address;
        this.level = dto.level;
        this.nextLevel = dto.nextLevel;
        this.imageUrl = dto.imageUrl;
        this.area = dto.area;
        this.city = dto.city;
        this.costPerSqft = dto.costPerSqft;
        this.sqft = dto.sqft;
        this.floors = dto.floors;
        this.borough = dto.borough;
        this.zipCode = dto.zipCode;
        this.upgradePointsBalance = dto.upgradePointsBalance;
        this.requiredUpgradePoints = dto.requiredUpgradePoints;
        this.visitCostInCoinsUpTo = dto.visitCostInCoinsUpTo;
        if (dto.landlord != undefined) {
            this.landlord = new LandlordData(dto.landlord);
        }
        this.piggyClubNftMultiplier = dto.piggyClubNftMultiplier;
        this.piggyClubImageUrl = dto.piggyClubImageUrl;
        this.piggyMultiplier = dto.piggyMultiplier ?? 0;
        this.priceInUsd = dto.priceInUsd ?? 0;
        this.priceInEth = dto.priceInEth ?? 0;
        this.marketplaceId = dto.marketplaceId;
        this.tokenId = dto.tokenId;
        this.minBuildingLevelToAddToMp = dto.minBuildingLevelToAddToMp;
        this.needToFix = dto.needToFix ?? false;
        this.purchaseHistory = [];
        if (dto.purchaseHistory == null) {
            return;
        }
        for (const purchaseHistoryDto of dto.purchaseHistory) {
            this.purchaseHistory.push(new PurchaseHistory(purchaseHistoryDto));
        }
    }

    private validateDto(dto: GuestBuildingsDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "address",
            "level",
            "imageUrl",
            "area",
            "city",
            "costPerSqft",
            "sqft",
            "floors",
            "borough",
            "zipCode",
            "upgradePointsBalance",
            "visitCostInCoinsUpTo",
            "minBuildingLevelToAddToMp"
        ]);
    }
}
